:host{display:flex;width:100%;font-family:Maison Neue,sans-serif}:host .client-batch-id-label{color:#232426;opacity:.6;min-width:83px}:host .client-batch-id{margin-left:auto;word-break:break-all}
/*# sourceMappingURL=client-batch-id.component.css.map */
